(function () {
    'use strict';
    eoRichTextEditorController.$inject = ['$scope', '$attrs', '$element'];

    function eoRichTextEditorController($scope, $attrs, $element) {
        var $ctrl = this;
        $ctrl.hasHtmlTags = false;

        $scope.$watch('$ctrl.inputValue', function () {
            if ($ctrl.inputValue) {
                if ($ctrl.inputValue.indexOf('<p>') > -1
                    || $ctrl.inputValue.indexOf('<div>') > -1
                    || $ctrl.inputValue.indexOf('<b>') > -1
                    || $ctrl.inputValue.indexOf('<font') > -1
                    || $ctrl.inputValue.indexOf('<span>') > -1
                )
                    $ctrl.hasHtmlTags = true;
            }

        });
    }

    var eo_RichTextEditor = {

        templateUrl: 'app/components/eyeson/rich-text-editor/eyeson.rich-text-editor.template.html',
        controller: eoRichTextEditorController,
        bindings: {
            inputValue: "=",
            height: "=?"

        }
    };
    angular
        .module('tikonApp')
        .component('eoRichTextEditor', eo_RichTextEditor);

})();

